import { useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type { ReserveProductRequest } from '@bvengineering/cas-member-gateway-service-client';
import { useApiMutation } from '@/api/hooks/useMutation';
import { campaignKeys } from '@/api/queryKeys';

type Request = {
  campaignId: number;
  casProductId: number;
  reserveProductRequest: ReserveProductRequest;
};

/** Reserves a product (variant) for a campaign. */
export function useReserveProduct() {
  const queryClient = useQueryClient();

  return useApiMutation<void, AxiosError, Request>({
    mutationFn:
      (api) =>
      async ({ campaignId, casProductId, reserveProductRequest }) => {
        await api.campaigns.campaignsControllerReserveProduct(
          campaignId,
          casProductId,
          reserveProductRequest
        );
      },
    onSuccess: async (_data, { campaignId }) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: campaignKeys.detail(campaignId) }),
        queryClient.invalidateQueries({ queryKey: campaignKeys.lists() }),
      ]);
    },
  });
}
